module.exports = __webpack_public_path__ + "static/media/2.b7e098a0.jpg";